import { useEffect, useState } from 'react'
import { CartAPI } from '../../apis/CartAPI'
import {
    getAddOnsProductsFromCart,
    getAddOnsofItem,
    getMainProductsFromCart,
} from '../../helpers/checkout'
import { NoticeStore } from '../../state/NoticeStore'
import Loader from '../Loader'
import { CartHeader } from './CartHeader'
import { CartRow } from './CartRow'
import { getErrorMessage, log } from '../../helpers/utils'

/**
 * @TODO 3 Aug
 * Upload files when adding to cart
 * figureout adding a customer to cart, using may be start session
 * checking out as store api or may be add customer afterwords.
 */

//  http://woocommerce.local/wp-json/olm-plugin/v1/get-wp-session?session_key=1

function CartRows({ cart, afterRemoveItem, order_id, mapped_metas }) {
    // const Storecart = CartStore((state) => state.cart)
    // const removeRow = CartStore((state) => state.remove)

    const { items } = cart
    const addNotice = NoticeStore((state) => state.add)
    const [loading, setLoading] = useState(false)
    const [addOns, setAddOns] = useState([])
    const [mainItems, setMainItems] = useState([])

    /**
     * Should we change remove from index to search ?
     */

    const afterRemove = async (updatedCart) => {
        log('afterRemoveItem', await afterRemoveItem(updatedCart))
        addNotice({
            type: 'success',
            children: 'Item removed from cart.',
        })
    }

    const afterRemoveError = (message) => {
        // await afterRemoveItem()
        addNotice({
            type: 'error',
            children: message,
        })
    }

    const removeRow = async (key) => {
        try {
            setLoading(true)
            const updatedCart = await removeItems(key)
            await afterRemove(updatedCart)
        } catch (e) {
            afterRemoveError(getErrorMessage(e))
        } finally {
            setLoading(false)
        }
    }

    const findItem = (key) => {
        return items.find((item) => item.key === key)
    }

    const removeItems = async (key) => {
        try {
            const item = findItem(key)
            const itemAddons = getAddOnsofItem(item, addOns)

            let keys = []
            keys.push(item.key)

            // await CartAPI.removeItem(item.key)

            if (itemAddons.length > 0) {
                for (const addOn of itemAddons) {
                    keys.push(addOn.key)
                }
            }
            // const { data } = await CartAPI.removeItems(keys)
            return await CartAPI.removeItems(keys)
            // return data
        } catch (e) {
            throw Error(e)
        }
    }

    const handleItems = () => {
        const mainItems = getMainProductsFromCart(cart)
        const AddOns = getAddOnsProductsFromCart(cart)
        setAddOns(AddOns)
        setMainItems(mainItems)
    }

    useEffect(() => {
        handleItems()
        return () => {
            setAddOns([])
            setMainItems([])
        }
    }, [items])

    if (items.length < 1) return null

    return (
        <div data-element-id="cart-rows" className="flex flex-col">
            {loading && <Loader />}
            <CartHeader />
            {mainItems.length > 0 &&
                mainItems.map((item, index) => (
                    <CartRow
                        removeRow={removeRow}
                        id={mapped_metas[item.key]}
                        mapped_metas={mapped_metas}
                        item={item}
                        order_id={order_id}
                        addOns={getAddOnsofItem(item, addOns)}
                        key={index}
                        afterRemove={afterRemove}
                        cart={cart}
                    />
                ))}
        </div>
    )
}

export default CartRows
